var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.chartIsLoading)?_c('v-progress-linear',{attrs:{"striped":"","color":"success","background-color":"cyan","height":"16","buffer-value":_vm.buffer,"value":_vm.value,"stream":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_c('span',{staticClass:"font-weight-bold text--secondary"},[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}],null,false,3198981295)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }